export const MAX_TOP_SKILLS_COUNT = {
  create_job: 3,
  talent_profile: 4,
} as const;
